<template>
	<div class="flex flex-col w-full bg-stone-100 select-none h-full" :class="{ 'bg-stone-700 text-stone-300 dark': !light_theme }" style="min-height: 100vh" >	
		<div class="w-full flex flex-row" :class="{'bg-stone-900 text-stone-300': !light_theme}">
			<div class="container mx-auto flex flex-row items-center justify-between p-4">
				<div class="flex flex-row items-center gap-4">
					<router-link :to="{ name: 'Home'}" class="py-2 px-2 rounded-full flex flex-col items-center justify-center font-bold dark:text-stone-900" style="background-color: rgb(255, 205, 9)">
						<img :src="require('@/assets/logo-192x192.png')" class="h-8" />
						<!-- <div>SultanTAXI</div>
						<div class="text-xs mt-[-6px]">межгород</div> -->
					</router-link>
					<!-- <div class="h-8 w-8 rounded-full bg-stone-500"></div> -->
					<!-- <div class="h-8 w-8 rounded-full bg-stone-300"></div> -->
					<!-- <img src="https://t3.ftcdn.net/jpg/04/68/17/58/360_F_468175854_cEU6WqxN6Q504R3L7CkDI38Jkh7tYVH4.jpg" class="h-12 rounded-md" /> -->
					<div class="text-2xl font-semibold">{{ loc($route.meta.title) }}</div>
				</div>
				<div class="flex items-center justify-start p-2 gap-4 overflow-hidden cursor-pointer">
					<div class="w-10 p-1 rounded-full flex items-center justify-center select-none" @click="toggleTheme"
						:class="[ light_theme ? 'bg-stone-200' : 'bg-stone-700']">
						<img v-if="light_theme" class="h-8 w-8 p-1" src="https://cdn-icons-png.flaticon.com/512/4445/4445942.png"/>
						<img v-else  class="h-8 w-8" src="https://img.icons8.com/?size=100&id=15352&format=png&color=000000"/>
					</div>
					<div v-if="this.$store.state.user === undefined" class="p-2 rounded-full bg-stone-200">
						<router-link :to="{ name: 'Login' }" class="p1-2 rounded-full bg-stone-300">
							<img  class="h-8 w-8" src="https://img.icons8.com/?size=256w&id=23265&format=png"/>
						</router-link>
					</div>
					<div v-else  class="p-2 rounded-full bg-stone-300">
						<router-link :to="{ name: 'Account' }" class="p1-2 rounded-full bg-stone-300">
							<img  class="h-8 w-8" src="https://img.icons8.com/?size=256w&id=23265&format=png"/>
						</router-link>
					</div>
				</div>
			</div>
		</div>
		<div class="container mx-auto transition-all dark:bg-stone-700 dark:text-stone-500 w-full py-8" style="height: 100%">
			<!-- {{  this.$store.state.user }} -->
			<router-view/>
		</div>
		<div v-if="this.$store.state.user != undefined" class="fixed bottom-0 left-0 w-full bg-stone-200 dark:bg-stone-600 dark:text-stone-200">
			<div class="container mx-auto flex flex-row items-center justify-around pt-2 pb-2">
				<!-- <div>
					<a href="whatsapp://send?text=https://sultantaxi.kz/ Междугородние поездки с SultanTAXI!" data-action="share/whatsapp/share" class="flex flex-row items-center text-lg gap-1 pr-4 bg-emerald-700 justify-center rounded-full text-white font-semibold" target="_blank">
						<img src="https://i.pinimg.com/474x/6e/69/25/6e69252a910770fbd9d3ddef65d1d5a4.jpg"  class="rounded-full h-12"/>
						<div>Поделиться</div>
					</a>
				</div> -->
				<div v-for="navItem, index in navMenu" :key="index" class="flex flex-col justify-center items-center">
					<router-link :to="navItem.to" class="flex flex-col items-center gap-1">
						<div class="h-12 w-12 rounded-full bg-lime-300 mb-1" :style="{'background-image': 'url(' + navItem.icon + ')'}" style="background-size: 75%; background-position: center; background-repeat: no-repeat"></div>
						<div class="text-sm font-semibold mt-[-6px]">{{ navItem.title }}</div>
					</router-link>
				</div>
			</div>
		</div>
	</div>
	<!-- <div v-else class="flex justify-center items-center h-full">
		<div class="text-3xl font-bold">
			<img src="https://upload.wikimedia.org/wikipedia/commons/5/53/Loading-red-spot.gif" >
		</div>
	</div> -->
</template>

<script>
// @ is an alias to /src
import Locales from '@/mixins/Locales'

export default {
    name: 'DashboardWrap',
	data () {
		return {
            user: undefined,
			collapsed: false,
			light_theme: true,
		}
	},
    methods: {
        logoutUser () {
			this.user = undefined
			this.$store.dispatch('logoutUser')
        },
        refreshUser () {
			this.$store.dispatch('getUser')
        },
		toggleTheme () {
			this.light_theme = !this.light_theme
			if (this.light_theme) {
				document.cookie = encodeURIComponent("theme") + '=' + encodeURIComponent("light")
			} else {
				document.cookie = encodeURIComponent("theme") + '=' + encodeURIComponent("dark")
			}
		},
		getThemeCookie () {
			let themeCookie = 'light'
			let name = "theme=";
			let decodedCookie = decodeURIComponent(document.cookie);
			let ca = decodedCookie.split(';');
			for(let i = 0; i <ca.length; i++) {
				let c = ca[i];
				while (c.charAt(0) == ' ') {
					c = c.substring(1);
				}
				if (c.indexOf(name) == 0) {
					themeCookie = c.substring(name.length, c.length);
				}
			}

			return themeCookie === 'light'
		}
	},
	computed: {
		navMenu () {
			const navMenu = []
			if (this.$store.state.user?.role == 'passenger') {
				navMenu.push({
					to: { name: 'MyPassengerOffers' },
					title: Locales.methods.loc('my_offers_page_title'),
					icon: 'https://img.icons8.com/?size=512w&id=eYd0VSqG1GBp&format=png'
				})
				navMenu.push({
					to: { name: 'TransporterOffersActive' },
					title: Locales.methods.loc('transporter_offers_active_page_title'),
					icon: 'https://img.icons8.com/?size=512w&id=3xOrU6jMUB6H&format=png'
				})
				navMenu.push({
					to: { name: 'PassengerOffersCreate' },
					title: 'Добавить заказ',
					icon: require('@/assets/create_offer_icon.png')
				})
			}
			if (this.$store.state.user?.role == 'transporter') {
				navMenu.push({
					to: { name: 'MyTransporterOffers' },
					title: Locales.methods.loc('my_offers_page_title'),
					icon: 'https://img.icons8.com/?size=512w&id=eYd0VSqG1GBp&format=png'
				})
				navMenu.push({
					to: { name: 'PassengerOffersActive' },
					title: Locales.methods.loc('passenger_offers_active_page_title'),
					icon: require('@/assets/wavingman.png')
				})
				navMenu.push({
					to: { name: 'TransporterOffersCreate' },
					title: 'Добавить заказ',
					icon: require('@/assets/create_offer_icon.png')
				})
			}
			return navMenu
		}
	},
    mounted () {
		this.refreshUser()
        this.user = this.$store.state.user
		this.light_theme = this.getThemeCookie()
    },
    watch: {
        '$store.state.user': function () {
            this.user = this.$store.state.user
        }
    }
}
</script>
<style scoped>
</style>
